import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 bg-white" data-id="element-164">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-165">
        <FadeIn data-id="element-166">
          <div className="bg-emerald text-white rounded-3xl p-8 md:p-12 relative overflow-hidden shadow-xl" data-id="element-167">
            {/* Decorative background */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl" data-id="element-168" />
            <Quote className="absolute top-8 left-8 w-24 h-24 text-white/10 rotate-180" data-id="element-169" />

            <div className="relative z-10" data-id="element-170">
              <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center font-serif" data-id="element-171">
                Lo que cambia en 7 días:
              </h2>

              <p className="text-lg md:text-xl leading-relaxed text-center font-medium italic" data-id="element-172">
                "Al finalizar la primera semana, notarás que tus anillos entran
                y salen con facilidad, el dolor punzante en los talones al dar
                el primer paso del día desaparece, y tu digestión se vuelve
                silenciosa y ligera por primera vez en años."
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}